class Wishlist {
  constructor() {
    this.storageKey = 'dhaanifoods_wishlist';
    this.items = JSON.parse(localStorage.getItem(this.storageKey)) || [];
    this.bindEvents();
    
    // Ensure initial initialization runs once DOM is ready or immediately if already ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initButtons());
    } else {
      this.initButtons();
    }
  }

  save() {
    localStorage.setItem(this.storageKey, JSON.stringify(this.items));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: this.items }));
  }

  add(handle) {
    if (!this.items.includes(handle)) {
      this.items.push(handle);
      this.save();
    }
  }

  remove(handle) {
    this.items = this.items.filter(item => item !== handle);
    this.save();
  }

  toggle(handle) {
    if (this.contains(handle)) {
      this.remove(handle);
      return false;
    } else {
      this.add(handle);
      return true;
    }
  }

  contains(handle) {
    return this.items.includes(handle);
  }

  initButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      if (btn.dataset.wishlistInit === 'true') return;
      btn.dataset.wishlistInit = 'true';

      const handle = btn.dataset.productHandle;
      if (!handle) return;

      if (this.contains(handle)) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isActive = this.toggle(handle);
        if (isActive) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    });
  }

  bindEvents() {
    document.addEventListener('wishlist:updated', (e) => {
      this.items = e.detail;
      this.updateHeaderIcon();
      this.updateAllButtons();
    });

    // Re-initialize buttons and header icon whenever DOM changes (handles dynamic content and AJAX section updates)
    const observer = new MutationObserver(() => {
      observer.disconnect();
      this.initButtons();
      this.updateHeaderIcon();
      observer.observe(document.body, { childList: true, subtree: true });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Ensure header is updated
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.updateHeaderIcon());
    } else {
      this.updateHeaderIcon();
    }
  }
  
  updateAllButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const handle = btn.dataset.productHandle;
      if (this.contains(handle)) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });
  }

  updateHeaderIcon() {
    const badge = document.querySelector('[data-wishlist-badge]');
    if (badge) {
      if (this.items.length > 0) {
        badge.textContent = this.items.length;
        badge.classList.remove('hidden');
      } else {
        badge.classList.add('hidden');
        badge.textContent = '';
      }
    }
  }
}

// Initialize Wishlist logic globally
window.wishlist = new Wishlist();
